import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { InfoGroupKeyComponent } from './info-group-key/info-group-key.component';
import { InfoGroupValueComponent } from './info-group-value/info-group-value.component';
import { InfoGroupComponent } from './info-group.component';

@NgModule({
	declarations: [InfoGroupComponent, InfoGroupKeyComponent, InfoGroupValueComponent],
	imports: [
		CommonModule,
	],
	exports: [InfoGroupComponent, InfoGroupKeyComponent, InfoGroupValueComponent],
})
export class InfoGroupModule { }
